const e = "styles-module__checkboxInputLabel___TPq-Q", c = "styles-module__checkboxInput___cmIYQ", o = "styles-module__error___Qg7mA", t = {
  checkboxInputLabel: e,
  checkboxInput: c,
  error: o
};
export {
  c as checkboxInput,
  e as checkboxInputLabel,
  t as default,
  o as error
};
